import { render, staticRenderFns } from "./VectorGeometryViz.vue?vue&type=template&id=19cf597d&scoped=true"
import script from "./VectorGeometryViz.vue?vue&type=script&lang=js"
export * from "./VectorGeometryViz.vue?vue&type=script&lang=js"
import style0 from "./VectorGeometryViz.vue?vue&type=style&index=0&id=19cf597d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cf597d",
  null
  
)

export default component.exports